
export default {
  props: {
    pageType: { type: String, required: true },
    theme: { type: String, required: false, default: 'bg-theme-tertiary' },
  },
}
